import { z } from 'zod'

export const adSlotSchema = z.object({
  dynamicBannerAdSlots: z.array(z.string()),
  dynamicOutstreamAdSlots: z.array(z.string()),
  dynamicRectangleAdSlots: z.array(z.string()),
  nativeAdSlots: z.array(z.string()),
  staticFooterAdSlots: z.array(z.string()),
  staticHeaderAdSlots: z.array(z.string()),
  staticSideAdSlots: z.array(z.string())
})

// Map for simplifying the ad slot names
export const SIMPLIFIED_AD_SLOT_TYPE_MAP = {
  banner: 'dynamicBannerAdSlots',
  outstream: 'dynamicOutstreamAdSlots',
  rectangle: 'dynamicRectangleAdSlots',
  native: 'nativeAdSlots',
  footer: 'staticFooterAdSlots',
  header: 'staticHeaderAdSlots',
  side: 'staticSideAdSlots'
} as const

export type AdSlotType = keyof typeof SIMPLIFIED_AD_SLOT_TYPE_MAP

export const deviceTypeSchema = z.enum(['mobile', 'desktop'])

export type DeviceType = z.infer<typeof deviceTypeSchema>

export const adSlotsConfigurationSchema = z.record(deviceTypeSchema, adSlotSchema)

export type AdSlotsConfiguration = z.infer<typeof adSlotsConfigurationSchema>

export const adPlacementSchema = z.object({
  rectangleVsBannerSplit: z.number().nullish(),
  firstDynamicAdAfterBlockNumber: z.number().nullish(),
  placeOutstreamAfterAmountOfDisplayAds: z.number().nullish(),
  minimumDynamicAdDistance: z.number().nullish(),
  noDisplayAdBefore: z.array(z.string()).nullish(),
  noDisplayAdAfter: z.array(z.string()).nullish(),
  showOutstreamAd: z.boolean().nullish(),
  noOutstreamAdBefore: z.array(z.string()).nullish(),
  noOutstreamAdAfter: z.array(z.string()).nullish(),
  firstRelatedBlockDistance: z.number().nullish(),
  minimumDistanceBetweenRelatedBlocks: z.number().nullish(),
  noRelatedBlockBefore: z.array(z.string()).nullish(),
  noRelatedBlockAfter: z.array(z.string()).nullish(),
  nativeTeasersPerRelatedBlock: z.number().nullish(),
  nativeTeasersPerQuadrupleTeaser: z.number().nullish()
})

export type AdPlacement = z.infer<typeof adPlacementSchema>

export const pageTypeSchema = z.enum(['article', 'authorPage', 'commerceArticle', 'home', 'overviewPage', 'staticPage'])

export type PageType = z.infer<typeof pageTypeSchema>

export const adPlacementConfigSchema = z.record(pageTypeSchema, z.record(deviceTypeSchema, adPlacementSchema))

export type AdPlacementConfig = z.infer<typeof adPlacementConfigSchema>
